"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _reactAutobind = require("react-autobind");

var _reactAutobind2 = _interopRequireDefault(_reactAutobind);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _calendar = require("../../assets/js/calendar.js");

var _calendar2 = _interopRequireDefault(_calendar);

require("../../assets/css/components/calendar/calendar.css");

var _InputField = require("../form/InputField");

var _InputField2 = _interopRequireDefault(_InputField);

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _Data = require("../../helpers/Data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://github.com/mdehoog/Semantic-UI-Calendar
// SUI calendar depends on SUI popup
_jquery2.default.fn.popup = require("semantic-ui-popup");
_jquery2.default.fn.transition = require("semantic-ui-transition");

(0, _calendar2.default)(_jquery2.default, document.defaultView || document.parentWindow, document, undefined);

var Calendar = function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar(props) {
    _classCallCheck(this, Calendar);

    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _this.handleInputFocus = function () {
      _this.setState({ focus: true });
    };

    _this.handleInputBlur = function () {
      _this.setState({ focus: false });
    };

    _this.getClearButton = function () {
      if (_this.props.onClear) return _react2.default.createElement(
        "button",
        {
          type: "button",
          className: "calendar-clear-btn",
          onClick: _this.props.onClear
        },
        _react2.default.createElement(_Icone2.default, { icone: "close" })
      );
    };

    _this.state = {
      focus: false,
      value: null
    };

    (0, _reactAutobind2.default)(_this);
    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var calendarConfig = this.props.calendarConfig || { type: "date" }; // 'datetime', 'date', 'time', 'month', 'year'
      this.$container = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      this.$container.calendar(_extends({
        onChange: this.handleChange,
        monthFirst: false,
        ampm: false,
        formatter: {
          date: function date(_date, settings) {
            return (0, _Data.formatLongToDate)((0, _moment2.default)(_date).toISOString());
          }
        }
      }, calendarConfig));
    }
  }, {
    key: "getNewValue",
    value: function getNewValue(nextProps) {
      return typeof nextProps.value === "string" ? nextProps.value : typeof nextProps.value === "number" ? (0, _moment2.default)(new Date(nextProps.value)).toISOString() : (0, _moment2.default)(nextProps.value).toISOString(); // tipo Date
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var focus = this.state.focus;
      var oldValue = this.state.value;

      var newValue = this.getNewValue(nextProps);

      var calendarConfig = nextProps.calendarConfig || { type: "date" };

      if (newValue !== null && newValue !== undefined && newValue.length > 0 && newValue !== "Invalid date") {
        if (!focus && newValue !== oldValue) {
          if (calendarConfig.type === "datetime") {
            newValue = (0, _moment2.default)(newValue).format("YYYY/DD/MM HH:mm");
          } else {
            newValue = (0, _moment2.default)(newValue).format("YYYY/DD/MM");
          }

          // newValue = moment(newValue).format()
          this.$container.calendar("set date", newValue, true, // updateInput
          false);
        }
      } else {
        // newValue = moment(newValue).format()
        this.$container.calendar("set date", "", true, // updateInput
        false);

        // Removendo do html
        document.getElementById(nextProps.name).removeAttribute("value");
      }

      this.setState({ value: newValue });

      if (nextProps.maxDate) {
        this.$container.calendar("setting", {
          minDate: new Date(nextProps.maxDate)
        });
      }

      if (nextProps.minDate) {
        this.$container.calendar("setting", {
          minDate: new Date(nextProps.minDate)
        });
      }

      this.$container.calendar("refresh");
    }
  }, {
    key: "getMinDate",
    value: function getMinDate(minDate) {
      if (this.props.minDateRelative) {
        return new Date(minDate) < new Date() ? new Date() : new Date(minDate);
      }
      return new Date(minDate);
    }
  }, {
    key: "getInitialDate",
    value: function getInitialDate(props) {
      if (props.initialDate) {
        if (props.minDate) {
          return new Date(props.minDate) > new Date(props.initialDate) ? new Date(props.minDate) : new Date(props.initialDate);
        } else return new Date(props.initialDate);
      }
      return props.minDate ? new Date(props.minDate) : null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.$container) this.$container.calendar("destroy");
    }
  }, {
    key: "handleChange",
    value: function handleChange(value, text) {
      value = value ? (0, _moment2.default)(value).toISOString() : "";
      var _props = this.props,
          onChange = _props.onChange,
          name = _props.name;

      var texto = (0, _Data.formatLongToDate)(value);
      var valor = value;
      if (onChange) {
        onChange({}, { name: name, text: texto, value: valor });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var inputProps = _extends({
        icon: "date_range",
        iconPosition: "left"
      }, _lodash2.default.omit(this.props, "onChange", "value", "calendarConfig"));
      var calendarConfig = this.props.calendarConfig || { type: "date" };
      var defaultValue = _lodash2.default.defaultTo(this.props.value, inputProps.defaultValue);

      if (defaultValue) {
        // inputProps.value = formatLongToStringDate(defaultValue)
        if (calendarConfig.type === "datetime") {
          inputProps.defaultValue = (0, _moment2.default)(defaultValue).format("DD/MM/YYYY HH:mm");
        } else {
          inputProps.defaultValue = (0, _moment2.default)(defaultValue).format("DD/MM/YYYY");
        }
      } else {
        // inputProps.value = ""
        inputProps.defaultValue = undefined;
      }

      return _react2.default.createElement(
        _InputField2.default,
        _extends({
          className: "ui calendar",
          width: this.props.width,
          phoneWidth: this.props.phoneWidth,
          tabletWidth: this.props.tabletWidth,
          icon: "date_range"
        }, inputProps, {
          onBlur: this.handleInputBlur,
          onFocus: this.handleInputFocus
        }),
        this.getClearButton()
      );
    }
  }]);

  return Calendar;
}(_react2.default.Component);

Calendar.propTypes = {
  defaultValue: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  calendarConfig: _propTypes2.default.object
};
exports.default = Calendar;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/CalendarField.js
// module id = 583
// module chunks = 0